<template>
    <div class="finances">
        <div>
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <volunteer-finance-report-component :userId="userId" :authUser="authUser"/>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import VolunteerFinanceReportComponent from './VolunteerFinanceReportComponent'
import VolunteerBackend from './VolunteerBackendComponent'


export default {
    name: "VolunteerFinances",
    props: ['userId', 'authUser'],
    components:{
        VolunteerFinanceReportComponent,
        VolunteerBackend
    },

    data(){
        return{

        }
    }
}
</script>
<style lang="scss">
.finances .tabs__navigation-item + .tabs__navigation-item {
    border-left: none;
}
.finances{
    .dashboard_contents{
        padding: 0;
    }

    &__filters{
        padding: 20px 0;
        background: #fff;
        align-items: center;
        margin-bottom: 18px;
        &-item{
            width: auto;
        }
    }
    .custom-select-wrapper{
        margin: 0 auto;
    }
}


</style>
<style lang="scss" scoped>

.finances{
    padding: 32px 0;
    background: #eff1f5;

}

</style>
